module.exports = __webpack_public_path__ + "static/media/IoTFlowsLogoWhiteFont.50ec546d.png";